module.exports = __webpack_public_path__ + "img/yourself.aecdb40f.jpg";